<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'App',
  data () {
    return {}
  },
  computed: {
    ...mapState({
      config: state => state.config.config
    })
  },
  created: function () {
    if (!this.config) {
      this.fetchConfig({}).then(
        res => {
          if (res.code == 10000) {
            document.title = res.result.config_list.site_name
          } else {
            Toast(res.message)
          }
        },
        error => {
          Toast(error.message)
        }
      )
    }
  },
	mounted() {
		this.mui.plusReady( () =>{
				var backcount = 0;
				this.$mui.back = ()=> {
					let path = this.$route.path;
					console.log("path:"+path);
           
					if (this.arrTab.includes(path)) {
						// 主导航页
						if (this.$mui.os.ios) return;
						if (backcount > 0) {
							if (window.plus) plus.runtime.quit();
							return;
						}
						this.$toast('再点击一次退出应用!');
						backcount++;
						setTimeout( () =>{
							backcount = 0;
						}, 2000);
					} else {
						// 子页面
						console.log('子页面后退键');
						this.$router.go(-1);
					}
				};
			}
		)
	},
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    })
  }
}
</script>
